import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const TrashIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 6V15.375C4.5 15.9963 5.00368 16.5 5.625 16.5H12.375C12.9963 16.5 13.5 15.9963 13.5 15.375V6H4.5Z"
        {...svgAttrs}
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4998 3.375V3C10.4998 2.58579 10.164 2.25 9.74976 2.25H8.24976C7.83554 2.25 7.49976 2.58579 7.49976 3V3.375H4.12476C3.91765 3.375 3.74976 3.54289 3.74976 3.75V4.125C3.74976 4.33211 3.91765 4.5 4.12476 4.5H13.8748C14.0819 4.5 14.2498 4.33211 14.2498 4.125V3.75C14.2498 3.54289 14.0819 3.375 13.8748 3.375H10.4998Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default TrashIcon;
